import Phaser from "phaser";
import { REFERENCE_HEIGHT, REFERENCE_WIDTH } from "./constants";
import { BootScene } from "../scenes/BootScene";
import { MainMenuScene } from "../scenes/MainMenuScene";
import { LakeSelectScene } from "../scenes/LakeSelectScene";
import { GameplayScene } from "../scenes/GameplayScene";
import { GameOverScene } from "../scenes/GameOverScene";

export const gameConfig: Phaser.Types.Core.GameConfig = {
    type: Phaser.AUTO,
    parent: "app",
    width: REFERENCE_WIDTH,
    height: REFERENCE_HEIGHT,
    backgroundColor: "#0f4975",
    physics: {
        default: "arcade",
        arcade: {
            debug: false,
            gravity: { x: 0, y: 0 },
        },
    },
    scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: REFERENCE_WIDTH,
        height: REFERENCE_HEIGHT,
    },
    scene: [BootScene, MainMenuScene, LakeSelectScene, GameplayScene, GameOverScene],
};
